import Notification20 from '@carbon/icons-react/es/notification/20';
import { SecureRoute } from '@okta/okta-react';
import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { Switch } from 'react-router';
import styled from 'styled-components';
import { CompactMenu } from 'components/atoms/menu/compact-menu';
import { Page } from 'components/molecules/page';
import { HeaderWithIconTitle } from 'components/molecules/page/page';
import { MenuLink } from 'components/molecules/project-details/header/tabs/tabs';
import { NotificationsConfiguration } from 'components/organisms/notifications';
import { RoutePaths } from 'constant';
import { useTranslation } from 'hooks/use-translation';
import { ProjectTabsVisibility } from './project-tab-visibility';

const NotificationsConfigPage = styled(NotificationsConfiguration)`
  margin: 0;
  padding: var(--spacing-08);
`;
const Header = styled.span`
  align-items: center;
  display: flex;
  flex: 1;
`;

const Menu = styled(CompactMenu)`
  background-color: var(--white-100);
`;

export const CustomerNotificationSettingsPage: FC = () => {
  const title = useTranslation('settings.custom_portal_notification');

  return (
    <Page>
      <Page.Header
        $white
        sticky
        title={
          <Header>
            <HeaderWithIconTitle icon={<Notification20 />} title={title} />
          </Header>
        }
        tabs={
          <Menu defaultSelectedKeys={['1']} tabIndex={-1} mode="horizontal">
            <CompactMenu.Item key="1" tabIndex={-1}>
              <MenuLink
                to={`${RoutePaths.customerPortalNotificationSettings}/project-tabs`}
              >
                {useTranslation(
                  'settings.custom_portal_notification.project_tabs',
                )}
              </MenuLink>
            </CompactMenu.Item>
            <CompactMenu.Item key="2" tabIndex={-2}>
              <MenuLink
                to={`${RoutePaths.customerPortalNotificationSettings}/client-notification`}
              >
                {useTranslation(
                  'settings.custom_portal_notification.client_notification',
                )}
              </MenuLink>
            </CompactMenu.Item>
          </Menu>
        }
      />
      <Page.Content>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <Switch>
          <SecureRoute
            path={`${RoutePaths.customerPortalNotificationSettings}/project-tabs`}
            exact
          >
            <ProjectTabsVisibility />
          </SecureRoute>
          <SecureRoute
            path={`${RoutePaths.customerPortalNotificationSettings}/client-notification`}
            exact
          >
            <NotificationsConfigPage customerConfig />
          </SecureRoute>
        </Switch>
      </Page.Content>
    </Page>
  );
};
